const builderWidgets = [
  {
    id: 1,
    icon: "ri-building-4-line",
    label: "Total Builders",
    counter: "Error, Reload Page.",
    badge: "ri-arrow-up-s-fill",
    badgeColor: "success",
    percentage: "6.24",
    decimal: "2",
    prefix: "$",
    separator: ",",
    bgColor: "#007BFF14",

  },
  {
    id: 2,
    icon: "ri-check-fill",
    label: "Approved",
    counter: "Error, Reload Page.",
    badge: "ri-arrow-up-s-fill",
    badgeColor: "success",
    percentage: "3.67",
    decimal: "2",
    prefix: "$",
    separator: ",",
  },
  {
    id: 3,
    icon: "ri-error-warning-line",
    label: "Pending",
    counter: "Error, Reload Page.",
    percentage: "4.80",
    decimal: "2",
    prefix: "$",
    separator: ",",
  },
  {
    id: 4,
    icon: "ri-error-warning-line",
    label: "Rejected",
    counter: "Error, Reload Page.",
    percentage: "4.80",
    decimal: "2",
    prefix: "$",
    separator: ",",
  },
];

const builderDetailWidgets = [
  {
    id: 1,
    icon: "ri-building-4-line",
    label: "Total Properties",
    counter: "Error, Reload Page.",
    percentage: "6.24",
    decimal: "2",
    prefix: "$",
    separator: ",",
  },
  {
    id: 2,
    icon: " ri-check-fill",
    label: "Total Rented",
    counter: "Error, Reload Page.",
    percentage: "3.67",
    decimal: "2",
    prefix: "$",
    separator: ",",
  },
  {
    id: 3,
    icon: "ri-error-warning-line",
    label: "Total Sold",
    counter: "Error, Reload Page.",
    percentage: "4.80",
    decimal: "2",
    prefix: "$",
    separator: ",",
  },
  {
    id: 4,
    icon: " ri-error-warning-line",
    label: "Rejected",
    counter: "Error, Reload Page.",
    percentage: "4.80",
    decimal: "2",
    prefix: "$",
    separator: ",",
  },
];

const builderData = [
    { id: '#737', name: 'Floyd Miles', email: 'kenzi.lawson@example.com', phone: '(684) 555-0102', created: '22 Oct, 2020 12:30 PM', updated: '22 Oct, 2020 12:30 PM', status: 'Active' },
    { id: '#737', name: 'Eleanor Pena', email: 'deanna.curtis@example.com', phone: '(316) 555-0116', created: '24 May, 2020 12:30 PM', updated: '24 May, 2020 12:30 PM', status: 'Active' },
    { id: '#737', name: 'Arlene McCoy', email: 'debbie.baker@example.com', phone: '(405) 555-0128', created: '21 Sep, 2020 12:30 PM', updated: '21 Sep, 2020 12:30 PM', status: 'Active' },
    { id: '#737', name: 'Wade Warren', email: 'jessica.hanson@example.com', phone: '(480) 555-0103', created: '17 Oct, 2020 12:30 PM', updated: '17 Oct, 2020 12:30 PM', status: 'Active' },
    { id: '#737', name: 'Annette Black', email: 'alma.lawson@example.com', phone: '(808) 555-0111', created: '8 Sep, 2020 12:30 PM', updated: '8 Sep, 2020 12:30 PM', status: 'Active' },
    { id: '#737', name: 'Cody Fisher', email: 'sara.cruz@example.com', phone: '(252) 555-0126', created: '8 Sep, 2020 12:30 PM', updated: '8 Sep, 2020 12:30 PM', status: 'Active' },
    { id: '#737', name: 'Marvin McKinney', email: 'debra.holt@example.com', phone: '(704) 555-0127', created: '24 May, 2020 12:30 PM', updated: '24 May, 2020 12:30 PM', status: 'Active' },
    { id: '#737', name: 'Cameron Williamson', email: 'willie.jennings@example.com', phone: '(209) 555-0104', created: '1 Feb, 2020 12:30 PM', updated: '1 Feb, 2020 12:30 PM', status: 'Suspended' },

];

const forRentListingData = [
  {
    propertyId: "#4564",
    address: "123 Main St, Anytown, USA",
    propertyType: "Single Family",
    createdAt: "22 Oct, 2020 12:30 PM",
    updatedAt: "24 Oct, 2020 12:30 PM",
    status: "Live",
  },
  {
    propertyId: "#4565",
    address: "456 Oak Ave, Springfield, USA",
    propertyType: "Condo",
    createdAt: "10 Nov, 2021 10:00 AM",
    updatedAt: "12 Nov, 2021 11:00 AM",
    status: "Pending",
  },
  {
    propertyId: "#4566",
    address: "789 Pine Rd, Riverdale, USA",
    propertyType: "Apartment",
    createdAt: "05 Jan, 2022 09:15 AM",
    updatedAt: "07 Jan, 2022 10:30 AM",
    status: "Live",
  },
  {
    propertyId: "#4567",
    address: "321 Birch Blvd, Lakeside, USA",
    propertyType: "Townhouse",
    createdAt: "15 Mar, 2021 01:45 PM",
    updatedAt: "17 Mar, 2021 02:00 PM",
    status: "Rejected",
  },
  {
    propertyId: "#4568",
    address: "654 Maple St, Hillview, USA",
    propertyType: "Single Family",
    createdAt: "20 Feb, 2023 03:20 PM",
    updatedAt: "21 Feb, 2023 04:10 PM",
    status: "Live",
  },
  {
    propertyId: "#4569",
    address: "987 Cedar Ct, Brookfield, USA",
    propertyType: "Apartment",
    createdAt: "30 Jun, 2022 08:00 AM",
    updatedAt: "01 Jul, 2022 08:30 AM",
    status: "Pending",
  },
  {
    propertyId: "#4570",
    address: "159 Elm Dr, Fairview, USA",
    propertyType: "Condo",
    createdAt: "12 May, 2021 05:10 PM",
    updatedAt: "13 May, 2021 06:00 PM",
    status: "Live",
  },
  {
    propertyId: "#4571",
    address: "753 Walnut Ln, Greenfield, USA",
    propertyType: "Townhouse",
    createdAt: "01 Sep, 2020 07:25 AM",
    updatedAt: "02 Sep, 2020 08:00 AM",
    status: "Pending",
  },
  {
    propertyId: "#4572",
    address: "852 Poplar St, Newtown, USA",
    propertyType: "Single Family",
    createdAt: "18 Jul, 2023 11:45 AM",
    updatedAt: "19 Jul, 2023 12:30 PM",
    status: "Live",
  },
  {
    propertyId: "#4573",
    address: "951 Chestnut Ave, Oldtown, USA",
    propertyType: "Apartment",
    createdAt: "25 Aug, 2022 02:50 PM",
    updatedAt: "26 Aug, 2022 03:10 PM",
    status: "Rejected",
  },
];

const SoldListingData = [
  {
    propertyId: "#4564",
    address: "123 Main St, Anytown, USA",
    propertyType: "Single Family",
    soldTo: "John Doe",
    createdAt: "22 Oct, 2020 12:30 PM",
    updatedAt: "24 Oct, 2020 12:30 PM",
    status: "Sold",
  },
  {
    propertyId: "#4565",
    address: "456 Oak Ave, Springfield, USA",
    propertyType: "Condo",
    soldTo: "John Doe",
    createdAt: "10 Nov, 2021 10:00 AM",
    updatedAt: "12 Nov, 2021 11:00 AM",
    status: "Sold",
  },
  {
    propertyId: "#4566",
    address: "789 Pine Rd, Riverdale, USA",
    propertyType: "Apartment",
    soldTo: "John Doe",
    createdAt: "05 Jan, 2022 09:15 AM",
    updatedAt: "07 Jan, 2022 10:30 AM",
    status: "Sold",
  },
  {
    propertyId: "#4567",
    address: "321 Birch Blvd, Lakeside, USA",
    propertyType: "Townhouse",
    soldTo: "John Doe",
    createdAt: "15 Mar, 2021 01:45 PM",
    updatedAt: "17 Mar, 2021 02:00 PM",
    status: "Sold",
  },
  {
    propertyId: "#4568",
    address: "654 Maple St, Hillview, USA",
    propertyType: "Single Family",
    soldTo: "John Doe",
    createdAt: "20 Feb, 2023 03:20 PM",
    updatedAt: "21 Feb, 2023 04:10 PM",
    status: "Sold",
  },
  {
    propertyId: "#4569",
    address: "987 Cedar Ct, Brookfield, USA",
    propertyType: "Apartment",
    soldTo: "John Doe",
    createdAt: "30 Jun, 2022 08:00 AM",
    updatedAt: "01 Jul, 2022 08:30 AM",
    status: "Sold",
  },
  {
    propertyId: "#4570",
    address: "159 Elm Dr, Fairview, USA",
    propertyType: "Condo",
    soldTo: "John Doe",
    createdAt: "12 May, 2021 05:10 PM",
    updatedAt: "13 May, 2021 06:00 PM",
    status: "Sold",
  },
  {
    propertyId: "#4571",
    address: "753 Walnut Ln, Greenfield, USA",
    propertyType: "Townhouse",
    soldTo: "Albert Flores",
    createdAt: "01 Sep, 2020 07:25 AM",
    updatedAt: "02 Sep, 2020 08:00 AM",
    status: "Sold",
  },
  {
    propertyId: "#4572",
    address: "852 Poplar St, Newtown, USA",
    propertyType: "Single Family",
    soldTo: "John Doe",
    createdAt: "18 Jul, 2023 11:45 AM",
    updatedAt: "19 Jul, 2023 12:30 PM",
    status: "Sold",
  },
  {
    propertyId: "#4573",
    address: "951 Chestnut Ave, Oldtown, USA",
    propertyType: "Apartment",
    soldTo: "John Doe",
    createdAt: "25 Aug, 2022 02:50 PM",
    updatedAt: "26 Aug, 2022 03:10 PM",
    status: "Sold",
  },
];

const RentedListingData = [
  {
    propertyId: "#4564",
    address: "123 Main St, Anytown, USA",
    propertyType: "Single Family",
    rentedTo: "John Doe",
    createdAt: "22 Oct, 2020 12:30 PM",
    updatedAt: "24 Oct, 2020 12:30 PM",
    status: "Rented",
  },
  {
    propertyId: "#4565",
    address: "456 Oak Ave, Springfield, USA",
    propertyType: "Condo",
    rentedTo: "John Doe",
    createdAt: "10 Nov, 2021 10:00 AM",
    updatedAt: "12 Nov, 2021 11:00 AM",
    status: "Rented",
  },
  {
    propertyId: "#4566",
    address: "789 Pine Rd, Riverdale, USA",
    propertyType: "Apartment",
    rentedTo: "John Doe",
    createdAt: "05 Jan, 2022 09:15 AM",
    updatedAt: "07 Jan, 2022 10:30 AM",
    status: "Rented",
  },
  {
    propertyId: "#4567",
    address: "321 Birch Blvd, Lakeside, USA",
    propertyType: "Townhouse",
    rentedTo: "John Doe",
    createdAt: "15 Mar, 2021 01:45 PM",
    updatedAt: "17 Mar, 2021 02:00 PM",
    status: "Rented",
  },
  {
    propertyId: "#4568",
    address: "654 Maple St, Hillview, USA",
    propertyType: "Single Family",
    rentedTo: "John Doe",
    createdAt: "20 Feb, 2023 03:20 PM",
    updatedAt: "21 Feb, 2023 04:10 PM",
    status: "Rented",
  },
  {
    propertyId: "#4569",
    address: "987 Cedar Ct, Brookfield, USA",
    propertyType: "Apartment",
    rentedTo: "John Doe",
    createdAt: "30 Jun, 2022 08:00 AM",
    updatedAt: "01 Jul, 2022 08:30 AM",
    status: "Rented",
  },
  {
    propertyId: "#4570",
    address: "159 Elm Dr, Fairview, USA",
    propertyType: "Condo",
    rentedTo: "John Doe",
    createdAt: "12 May, 2021 05:10 PM",
    updatedAt: "13 May, 2021 06:00 PM",
    status: "Rented",
  },
  {
    propertyId: "#4571",
    address: "753 Walnut Ln, Greenfield, USA",
    propertyType: "Townhouse",
    rentedTo: "Albert Flores",
    createdAt: "01 Sep, 2020 07:25 AM",
    updatedAt: "02 Sep, 2020 08:00 AM",
    status: "Rented",
  },
  {
    propertyId: "#4572",
    address: "852 Poplar St, Newtown, USA",
    propertyType: "Single Family",
    rentedTo: "John Doe",
    createdAt: "18 Jul, 2023 11:45 AM",
    updatedAt: "19 Jul, 2023 12:30 PM",
    status: "Rented",
  },
  {
    propertyId: "#4573",
    address: "951 Chestnut Ave, Oldtown, USA",
    propertyType: "Apartment",
    rentedTo: "John Doe",
    createdAt: "25 Aug, 2022 02:50 PM",
    updatedAt: "26 Aug, 2022 03:10 PM",
    status: "Rented",
  },
];

const ArchivedListingData = [
  {
    propertyId: "#4564",
    address: "123 Main St, Anytown, USA",
    propertyType: "Single Family",
    createdAt: "22 Oct, 2020 12:30 PM",
    updatedAt: "24 Oct, 2020 12:30 PM",
    status: "Archived",
  },
  {
    propertyId: "#4565",
    address: "456 Oak Ave, Springfield, USA",
    propertyType: "Condo",
    createdAt: "10 Nov, 2021 10:00 AM",
    updatedAt: "12 Nov, 2021 11:00 AM",
    status: "Archived",
  },
  {
    propertyId: "#4566",
    address: "789 Pine Rd, Riverdale, USA",
    propertyType: "Apartment",
    createdAt: "05 Jan, 2022 09:15 AM",
    updatedAt: "07 Jan, 2022 10:30 AM",
    status: "Archived",
  },
  {
    propertyId: "#4567",
    address: "321 Birch Blvd, Lakeside, USA",
    propertyType: "Townhouse",
    createdAt: "15 Mar, 2021 01:45 PM",
    updatedAt: "17 Mar, 2021 02:00 PM",
    status: "Archived",
  },
  {
    propertyId: "#4568",
    address: "654 Maple St, Hillview, USA",
    propertyType: "Single Family",
    createdAt: "20 Feb, 2023 03:20 PM",
    updatedAt: "21 Feb, 2023 04:10 PM",
    status: "Archived",
  },
  {
    propertyId: "#4569",
    address: "987 Cedar Ct, Brookfield, USA",
    propertyType: "Apartment",
    createdAt: "30 Jun, 2022 08:00 AM",
    updatedAt: "01 Jul, 2022 08:30 AM",
    status: "Archived",
  },
  {
    propertyId: "#4570",
    address: "159 Elm Dr, Fairview, USA",
    propertyType: "Condo",
    createdAt: "12 May, 2021 05:10 PM",
    updatedAt: "13 May, 2021 06:00 PM",
    status: "Archived",
  },
  {
    propertyId: "#4571",
    address: "753 Walnut Ln, Greenfield, USA",
    propertyType: "Townhouse",
    createdAt: "01 Sep, 2020 07:25 AM",
    updatedAt: "02 Sep, 2020 08:00 AM",
    status: "Archived",
  },
  {
    propertyId: "#4572",
    address: "852 Poplar St, Newtown, USA",
    propertyType: "Single Family",
    createdAt: "18 Jul, 2023 11:45 AM",
    updatedAt: "19 Jul, 2023 12:30 PM",
    status: "Archived",
  },
  {
    propertyId: "#4573",
    address: "951 Chestnut Ave, Oldtown, USA",
    propertyType: "Apartment",
    createdAt: "25 Aug, 2022 02:50 PM",
    updatedAt: "26 Aug, 2022 03:10 PM",
    status: "Archived",
  },

];

const documentsData = [
    {
        documentId: '1',
        fileName: 'file1.pdf',
        description: 'desc',
        type: 'PDF',
        size: '1MB',
        createdAt: '2024-06-01',
        updatedAt: '2024-06-02',
        status: 'pending', // backend se aane wala status
        downloadUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
    },
    {
        documentId: '2',
        fileName: 'file2.pdf',
        description: 'desc',
        type: 'PDF',
        size: '1MB',
        createdAt: '2024-06-01',
        updatedAt: '2024-06-02',
        status: 'approve', // backend se aane wala status
        downloadUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
    },
    {
        documentId: '3',
        fileName: 'file3.pdf',
        description: 'desc',
        type: 'PDF',
        size: '1MB',
        createdAt: '2024-06-01',
        updatedAt: '2024-06-02',
        status: 'reject', // backend se aane wala status
        downloadUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
    },
];

const focalPersonData = [
    { id: '#737', name: 'Floyd Miles', email: 'kenzi.lawson@example.com', phoneNumber: '(684) 555-0102',roleAssigned: 'Admin', createdAt: '22 Oct, 2020 12:30 PM', updatedAt: '22 Oct, 2020 12:30 PM', status: 'pending' },
    { id: '#737', name: 'Eleanor Pena', email: 'deanna.curtis@example.com', phoneNumber: '(316) 555-0116',roleAssigned: 'Editor', createdAt: '24 May, 2020 12:30 PM', updatedAt: '24 May, 2020 12:30 PM', status: 'approved' },
    { id: '#737', name: 'Arlene McCoy', email: 'debbie.baker@example.com', phoneNumber: '(405) 555-0128',roleAssigned: 'Viewer', createdAt: '21 Sep, 2020 12:30 PM', updatedAt: '21 Sep, 2020 12:30 PM', status: 'pending' },
];

export { builderWidgets, builderDetailWidgets, forRentListingData, SoldListingData, RentedListingData, ArchivedListingData, builderData, documentsData, focalPersonData};

